module.exports = __webpack_public_path__ + "static/media/photo3.04d87b6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo3.png
// module id = 509
// module chunks = 0